import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "text-start fw-bold fs-7 text-uppercase gs-0 bg-custom" }
const _hoisted_2 = {
  key: 0,
  style: { width: '30px' }
}
const _hoisted_3 = { class: "form-check form-check-sm form-check-custom form-check-solid me-3" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("thead", null, [
    _createElementVNode("tr", _hoisted_1, [
      (_ctx.checkboxEnabled)
        ? (_openBlock(), _createElementBlock("th", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checked) = $event)),
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectAll()))
              }, null, 544), [
                [_vModelCheckbox, _ctx.checked]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.header, (column, i) => {
        return (_openBlock(), _createElementBlock("th", {
          key: i,
          class: _normalizeClass({
            'text-end': i === _ctx.header.length - 1,
          }),
          onClick: ($event: any) => (_ctx.onSort(column.columnLabel, column.sortEnabled)),
          style: _normalizeStyle({
            minWidth: column.columnWidth ? `${column.columnWidth}px` : '0',
            width: 'auto',
            cursor: column.sortEnabled ? 'pointer' : 'auto',
          })
        }, [
          _createTextVNode(_toDisplayString(column.columnName) + " ", 1),
          (
              _ctx.columnLabelAndOrder.label === column.columnLabel &&
              column.sortEnabled
            )
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                innerHTML: _ctx.sortArrow
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true)
        ], 14, _hoisted_4))
      }), 128))
    ])
  ]))
}